import { AxiosRequestConfig } from 'axios';
import { cookie } from '@q/solib-utils';
import userStore from '@/store/user';
import { ErrCodes } from './errcodes';
import { requestQueue } from './common';
import { sendRequest } from './request';
import { getLoginInfoByForceRefresh } from '../login-info';
import { refreshUserCookies } from '@/services/bizUserService';

const MAX_CONCURRENT_REQUEST = 6;
let activeRequest = 0;
const MAX_RETIRES = 3;
let refreshLoginInfoPromise: Promise<any> | null = null;

const refreshLoginInfo = (code: ErrCodes, pin: string) => {
  return getLoginInfoByForceRefresh().then(loginInfo => {
    const userInfo = loginInfo.data.userInfo;
    const Q = userInfo?.Q;
    const T = userInfo?.T;
    if (Q && T) {
      userStore.bizLoginInfo.token = loginInfo.data.token;
      if (code === ErrCodes.loginExpired) {
        cookie.set('Q', Q, {
          domain: 'n.cn',
          sameSite: 'None',
          path: '/',
          secure: true,
        });
        cookie.set('T', T, {
          domain: 'n.cn',
          sameSite: 'None',
          path: '/',
          secure: true,
        });
        return refreshUserCookies(Q, T, pin, userStore.bizLoginInfo.token).then((res) => {
          return res.errno ? Promise.reject('Failed to refresh cookies') : Promise.resolve()
        })
      }
    }
  });
};

/**
 * 处理请求队列
 */
export default async function processQueue() {
  const { token, pin } = userStore.bizLoginInfo || {}
  // 并发限制
  while (activeRequest < MAX_CONCURRENT_REQUEST && requestQueue.length > 0) {
    const reqConfig = requestQueue.shift() as AxiosRequestConfig & {
      resolve: (value: unknown) => void;
      reject: (value: unknown) => void;
      retires: number;
    };
    const { resolve, reject, retires, ...axiosRequestConfig } = reqConfig;
    activeRequest += 1;

    if (retires >= MAX_RETIRES) {
      return reject('Exceeded retries limit')
    }

    // 发送请求
    sendRequest(axiosRequestConfig, token, pin)
      .then(async res => {
        if (
          res.errno === ErrCodes.tokenInvalid ||
          res.errno === ErrCodes.loginExpired ||
          res.errno === ErrCodes.teamDataInvalid
        ) {
          if (refreshLoginInfoPromise) {
            refreshLoginInfoPromise.finally(() => {
              reqConfig.retires++;
              requestQueue.push(reqConfig);
            });
            return;
          }
          try {
            refreshLoginInfoPromise = refreshLoginInfo(res.errno, pin);
            await refreshLoginInfoPromise;
            reqConfig.retires++;
            requestQueue.push(reqConfig);
            refreshLoginInfoPromise = null;
          } catch (e) {
            reject(e)
          }
        } else {
          resolve(res);
        }
      })
      .finally(() => {
        activeRequest -= 1;
        processQueue();
      });
  }
}
